import { Stack } from "@fluentui/react";
import { animated, useSpring } from "@react-spring/web";
import { useTranslation } from "react-i18next";

import styles from "./Answer.module.css";
import { AnswerIcon } from "./AnswerIcon";

export const AnswerLoading = () => {
    const { t, i18n } = useTranslation();
    const animatedStyles = useSpring({
        from: { opacity: 0, transform: "translateY(20px)" },
        to: { opacity: 1, transform: "translateY(0px)" },
        config: { tension: 280, friction: 60 }
    });

    const currentTime = new Date().toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true
    });

    return (
        <animated.div style={{ ...animatedStyles }}>
            <Stack className={styles.answerContainer} verticalAlign="space-between">
                {/* Email-style header with loading indicator */}
                <div className={`${styles.emailHeader} ${styles.headerLoading}`}>
                    <div className={styles.headerLeft}>
                        <span className={styles.emailIcon}>🤖</span>
                        <div className={styles.emailMeta}>
                            <div className={styles.emailTitle}>{t("email.responseBanner")}</div>
                            <div className={styles.emailTimestamp}>{currentTime}</div>
                        </div>
                    </div>
                    <div className={styles.loadingSpinner}>
                        <div className={styles.spinner}></div>
                    </div>
                </div>

                {/* Loading content */}
                <Stack.Item grow>
                    <div className={styles.emailContent}>
                        <div className={styles.loadingContent}>
                            <div className={styles.loadingText}>
                                {t("generatingAnswer")}
                                <span className={styles.loadingdots} />
                            </div>
                            <div className={styles.loadingBars}>
                                <div className={styles.loadingBar}></div>
                                <div className={styles.loadingBar}></div>
                                <div className={styles.loadingBar}></div>
                            </div>
                        </div>
                    </div>
                </Stack.Item>
            </Stack>
        </animated.div>
    );
};
